"use client";

import { useEffect, useState } from "react";

import { Search } from "lucide-react";

import { abrirBuscador } from "@/components/docs/buscador";

/** Búsquedas reales que se escriben solas (2026-10-04, *«más elegante… animaciones»*): enseñan qué se puede buscar. */
const EJEMPLOS = ["factura de venta", "cierre de caja", "nota crédito", "liquidar la nómina", "facturación electrónica"];

/**
 * El buscador grande de la portada. **No es un segundo buscador**: es un botón que abre el mismo modal
 * que la cabecera, vía `abrirBuscador()`. Montar un `<Buscador>` aquí daría dos modales y dos atajos
 * `⌘K` peleándose — está explicado en `buscador.tsx`.
 */
export function BuscadorGrande() {
  const [texto, setTexto] = useState("");

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setTexto(EJEMPLOS[0]);
      return;
    }
    let i = 0;
    let n = 0;
    let borrando = false;
    let t: ReturnType<typeof setTimeout>;
    const paso = () => {
      const frase = EJEMPLOS[i];
      n += borrando ? -1 : 1;
      setTexto(frase.slice(0, n));
      let espera = borrando ? 30 : 65;
      if (!borrando && n >= frase.length) {
        borrando = true;
        espera = 1700;
      } else if (borrando && n <= 0) {
        borrando = false;
        i = (i + 1) % EJEMPLOS.length;
        espera = 350;
      }
      t = setTimeout(paso, espera);
    };
    t = setTimeout(paso, 700);
    return () => clearTimeout(t);
  }, []);

  return (
    <button
      type="button"
      onClick={abrirBuscador}
      className="flex w-full max-w-xl items-center gap-3 rounded-2xl border-2 bg-background px-4 py-3.5 text-left text-muted-foreground transition-colors hover:border-foreground/30"
    >
      <Search className="size-5 shrink-0" />
      <span className="flex-1">
        Buscar <span className="text-foreground">{texto}</span>
        <span className="vecipp-cursor ml-px inline-block h-4 w-px translate-y-0.5 bg-foreground" />
      </span>
      <kbd className="hidden shrink-0 rounded border px-1.5 py-0.5 font-medium font-sans text-xs sm:block">⌘K</kbd>
    </button>
  );
}
